import React from "react";
import BlogMaker from "./BlogMaker";

const BlogEditor = () => {
  return (
    <div>
      {/* <Canvas /> */}

      <BlogMaker />
    </div>
  );
};

export default BlogEditor;
